import type { ReactElement } from 'react';
import type { PreviewVenue } from '../types';
import { formatPrice } from 'utils/currencyUtils';

type Props = {
  venue: PreviewVenue;
};

export function VenuePreviewPrice(props: Props): ReactElement {
  const pricingPreview = pickVenuePricingPreview(props.venue);

  return pricingPreview ? (
    <p>
      {`${__('shared.venue_card.starting_from_prefix')} ${pricingPreview.formattedPrice} ${pricingPreview.legend}`}
    </p>
  ) : (
    <p>{__('shared.venue_card.request_quote')}</p>
  );
}

function venuePricingPreviewOption(
  venue: PreviewVenue
): { price: number; legend: string } | null {
  if (venue.rent_per_day !== null && venue.rent_per_day > 0) {
    return {
      price: venue.rent_per_day,
      legend: __('shared.venue_card.rent_per_day')
    };
  }
  if (venue.rent_per_hour !== null && venue.rent_per_hour > 0) {
    return {
      price: venue.rent_per_hour,
      legend: __('shared.venue_card.rent_per_hour')
    };
  }
  if (venue.rent_per_person !== null && venue.rent_per_person > 0) {
    return {
      price: venue.rent_per_person,
      legend: __('shared.venue_card.rent_per_person')
    };
  }
  if (venue.sales_guarantee !== null && venue.sales_guarantee > 0) {
    return {
      price: venue.sales_guarantee,
      legend: __('shared.venue_card.sales_guarantee')
    };
  }
  return null;
}

function pickVenuePricingPreview(
  venue: PreviewVenue
): { formattedPrice: string; legend: string } | null {
  const pricePreviewOption = venuePricingPreviewOption(venue);
  if (!pricePreviewOption) return null;

  return {
    legend: pricePreviewOption.legend,
    formattedPrice: formatPrice(pricePreviewOption.price, {
      precision: 0,
      locale: venue.locale
    })
  };
}
